import React, { PropTypes } from 'react'
import BaseModal from '../base-modal'
import { reduxForm } from 'redux-form'
import FormMessages, { generateValidation } from 'redux-form-validation'

const validations = {
  email: {
    required: true,
    email: true,
    validateOnBlur: true
  },
  redirect: {
    required: true
  }
}

const constraints = {
  'width': '415px',
  'minWidth': '415px'
}

const ForgotPasswordModal = ({fields: {email}, handleSubmit, submitting, error, handleClose}) => (
  <BaseModal
    onClose={handleClose}
    title='Forgot Your Password?'
    constraints={constraints}
    contentClassName='forgot-password-modal'>
    <p className='message'>
      Enter your email address below and we'll send you instructions on how to change your password.
    </p>
    <p className={(error && !submitting) ? 'error' : 'error hidden'}>{error && error.detail}</p>
    <form onSubmit={handleSubmit}>
      <input className='email-address' type='email' placeholder='Email Address' {...email} />
      <FormMessages tagName='ul' className='error-list' field={email}>
        <li when='required'>
          this field is required
        </li>
        <li when='email'>
          please insert a valid email
        </li>
      </FormMessages>
      <button className='submit-button' type='submit'>Send</button>
    </form>
  </BaseModal>
)

ForgotPasswordModal.propTypes = {
  fields: PropTypes.object.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submitting: PropTypes.bool,
  error: PropTypes.object,
  handleClose: PropTypes.func.isRequired
}

export default reduxForm({
  form: 'forgotPassword',
  ...generateValidation(validations)
})(ForgotPasswordModal)



// WEBPACK FOOTER //
// ./src/components/login/forgot-password.js